import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';
import { I18nModule } from '@softline/ui-core';

@Component({
  selector: 'soft-field-ok-artstamm-list-view',
  imports: [CommonModule, I18nModule],
  templateUrl: './artstamm.list-view.html',
  styleUrls: ['./artstamm.list-view.css'],
})
export class ArtstammListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
